import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { user } from '../model/user.fragments';
import { UserOutput } from '../model/user.output';

export interface UpdateCoacheeObserversInput {
	readonly coacheeId: string;
	readonly observersId: string[];
}

export interface UpdateCoacheeObserversParams {
	input: UpdateCoacheeObserversInput;
}

@Injectable({ providedIn: 'root' })
export class UpdateCoacheeObserversApiMutation extends ApiMutation<
	UserOutput,
	UpdateCoacheeObserversParams
> {
	client = 'iam';
	document = gql`
		mutation UpdateCoacheeObservers($input: UpdateCoacheeObserversInput!) {
			updateCoacheeObservers(input: $input) {
				...User
			}
		}
		${user}
	`;
	method = 'updateCoacheeObservers';
}
